import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import AssociationBoxViewModel from '@/ViewModels/Controls/AssociationBoxViewModel';

export default class ObjectLinkBoxViewModel extends ControlViewModel {

    /**
     * Das ViewModel für die AssociationBox
     */
    public associationBox: AssociationBoxViewModel;

    /**
     * Das ViewModel für die ObjectLinkBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params)

        this.associationBox = this.paramOrDefault(params.associationBox, null);
    }
}

ComponentManager.setViewModel('ObjectLinkBoxViewModel', ObjectLinkBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');